import { DateRange } from "react-date-range"
import "react-date-range/dist/styles.css" // main css file
import "react-date-range/dist/theme/default.css" // theme css file
import "./style/style.css"

interface props {
 setState?: React.Dispatch<React.SetStateAction<any[]>>
 state: any
 onChange?: any
}
export const CommonCalendar = ({ state, onChange = () => {} }: props) => {
 return (
  <div>
   <DateRange
    editableDateInputs={true}
    onChange={onChange}
    moveRangeOnFirstSelection={false}
    ranges={state}
    dayDisplayFormat="EEE d"
    rangeColors={["#FFF3C9"]}
    showMonthArrow={false}
   />
  </div>
 )
}
